module.exports = __webpack_public_path__ + "media/images/athletes/3307-50d800e44b55cfac3b6de2431026c282.png";